import { render, staticRenderFns } from "./o-confirm-modal.vue?vue&type=template&id=5c656fe4&"
import script from "./o-confirm-modal.vue?vue&type=script&lang=js&"
export * from "./o-confirm-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports